module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fxGEp"))).then(() => module.bundle.root('2KbAe'));